import React, { useState, useEffect } from 'react'
import axios from "axios";

const TrialUserRegistrationForm = props => {
    const {publicUrl, baseUrl, toolUrl, setUsageAllowed, setRegisteredForExtendedUsage, setMaxUsage, setTrialUserRegistered, displayTrialUserRegistrationFormModalClose} = props

    const [email, setEmail] = useState('')
    const [agreeToTerms, setAgreeToTerms] = useState(false)

    const [displayModalFeedbackMessage, setDisplayModalFeedbackMessage] = useState(false)
    const [modalFeedbackMessage, setModalFeedbackMessage] = useState('')
    const [modalError, setModalError] = useState(false)
    const [submitButtonDisabled, setSubmitButtonDisabled] = useState(true)

    console.log('in TrialUserRegistrationForm')

    useEffect(() => { validateForm() }, [ email, agreeToTerms ])

    const registerUserDetails = (email) => {

        console.log('in registerUserDetails', email)

        const params = {
            'tool_name': toolUrl,
            'email': email,
        }

        axios.post(baseUrl + 'add-trial-user-email/', {'params': params})
            .then(r => {
                console.log('add-trial-user-email response:', r.data)
                setDisplayModalFeedbackMessage(true)
                setModalError(r.data.status !== 'success')
                if( r.data.status === 'success' ) {
                    setTimeout(() => {
                        setUsageAllowed(true)
                        setRegisteredForExtendedUsage(true)
                        if( r.data.maxUsage )
                            setMaxUsage(r.data.maxUsage)
                        displayTrialUserRegistrationFormModalClose()
                        setTrialUserRegistered(true)
                    }, 1500);
                }
                setModalFeedbackMessage(r.data.message)
            })
            .catch(e => {
                console.log(e)
            })
    }

    const validEmail = (email) => {
        const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

        console.log('in validEmail', email, regex.test(email))

        if (!email || regex.test(email) === false) {
            return false
        }
        return true
    }

    const validateForm = () => {
        let validForm = agreeToTerms && validEmail(email )
        console.log('in validateForm',validForm)
        setSubmitButtonDisabled( !validForm )
    }

    const handleSetEmail = (email) => {
        let cleanedEmail = email.trim()
        setEmail(cleanedEmail)
    }

    const handleCheckboxEvent = (e) => {
        console.log('in handleCheckboxEvent', e.target.checked)
        setAgreeToTerms(e.target.checked)
    }

    const submitFormClick = (e) => {
        e.preventDefault()
        console.log('in submitFormClick')

        registerUserDetails(email)
        setSubmitButtonDisabled(true)
    }

    return (
        <div className="modal-new-style tools-page clear-design">
            <div className="modal-dialog" style={{width: 550 + 'px'}}>
                <div className="modal-content">
                    <div className="modal-header">
                        <div className="row">
                            <div className='col-xs-6 col-sm-3'>
                                <img src={publicUrl + 'img/mobile-moxie.png'} alt="" height="50"/>
                            </div>
                            <div className='col-xs-6 col-sm-9'>
                                <h3 style={{fontSize:16, paddingTop:5}}>Aw, you've used up your free tests.</h3>
                            </div>
                        </div>
                        <button type="button" className="close" onClick={displayTrialUserRegistrationFormModalClose}>
                            <i className="material-icons">clear</i>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="panel phone-view-body ma-0">
                            <div className="panel-body pa-10">
                                <div className="row">
                                    <div className="col-xs-12">
                                        <form>
                                            <p style={{fontSize:14}} className="alert alert-success pa-10 text-center">If you'd like to get an additional 3 free tests, sign up with your email below.</p>
                                            <div className="form-group has-feedback">
                                                <label className="control-label">
                                                    <strong>Email</strong>
                                                </label>
                                                <div className='input-section'>
                                                    <input
                                                        type='text'
                                                        id='email'
                                                        name='email'
                                                        onChange={e => handleSetEmail(e.target.value)}
                                                        className='form-control'/>
                                                </div>
                                            </div>
                                            <div className="form-group  input-section">
                                                <div className="form-group table">
                                                    <div className="checkbox ml-20">
                                                        <input
                                                            id='agreeToTerms'
                                                            name='agreeToTerms'
                                                            type="checkbox"
                                                            className="styled-react-checkbox"
                                                            style={{position:'fixed', marginTop:0}}
                                                            onClick={(e) => handleCheckboxEvent(e)}
                                                          />
                                                        <label className="control-label pa-0 pl-8" for="agreeToTerms">I agree to subscribe to the MobileMoxie email newsletter</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <p style={{fontSize:14}} className="alert alert-info pa-10 text-center">Want to get <strong>unlimited</strong> tests? Check out our <a href='https://mobilemoxie.com/pricing-plans/' target='_blank'>paid plans here.</a></p>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button
                            disabled={submitButtonDisabled}
                            onClick={(e) => submitFormClick(e)}
                            className="btn btn-primary addUrlBtn">Sign Up
                        </button>
                        <div className={displayModalFeedbackMessage ? '' : 'hidden'}>
                            <div className={'modal-feedback ' + (modalError ? 'modal-feedback-error' : 'modal-feedback-success')}>{modalFeedbackMessage}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TrialUserRegistrationForm
